<template>
  <div>
    <div
      class="land-home-carousel"
      :style="{ backgroundImage:'url('+bannerUrl+')'} "
    >
      <div style="width:1200px; margin:0 auto">
        <div class="solution-banner-title"> <div
                v-for="(desc,index) in bannerTitle.split(' ')"
                :key="index"
              >{{desc}}</div></div>
        <div class="solution-banner-text">{{bannerText}}</div>
      </div>
    </div>
  </div>
</template>

<script>
// const bannerUrl = require('../assets/images/land-page/land-home/news-banner.jpg')
export default {
  name: 'landBanner',
  data () {
    return {
      // bannerUrl
    }
  },
  props: {
    bannerUrl: {
      type: String,
      default: ''
    },
    bannerTitle: {
      type: String,
      default: ''
    },
    bannerText: {
      type: String,
      default: ''
    }

  }

}
</script>

<style lang="scss" scoped>
.land-home-carousel {
  // width: 1920px;
  width: 100%;
  height: 367px;
  margin: auto;
  background-color: #4499ff;
  background:no-repeat;
  background-size: cover;
  display: flex;
  // img {
  //   // height:367px ;
  //   display: block;
  //   width: 100%;
  //   height: 100%;
  // }

  .solution-banner-title {
    margin-top: 123px;
    // margin-left: 362px;
    width: 301px;
    font-size: 28px;
    font-weight: normal;
    color: #ffffff;
    line-height: 32px;
    letter-spacing: 2px;
  }
  .solution-banner-text {
    margin-top: 26px;
    // margin-left: 362px;
    width: 590px;
    font-size: 15px;
    font-weight: normal;
    color: #ffffff;
    line-height: 24px;
  }
}
</style>
